import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { CloseOutlined, UserOutlined } from '@ant-design/icons';

import {
  InfoModalContent,
  InfoModalHeader,
  InfoModalIcon,
  InfoModalBody,
  InfoModalText,
  InfoModalTitle,
  InfoModalFooter,
  InfoModalPrimaryButton,
  ModalCloseButton,
  InfoModalSpesificText,
} from '../Promotions/Modal.styles';
import HelpIcon from './Icons/HelpIcon';
import styled from '@emotion/styled';

const SupportLevelsInfoModal = ({ open, onClose }) => {
  const [innerWidth, setInnerWidth] = React.useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  React.useEffect(() => {
    const handleResize = () => setInnerWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <StyledModal
      open={open}
      onCancel={onClose}
      footer={null}
      width={600}
      closable={false}
      style={{
        marginTop: innerWidth < 1400 ? 0 : undefined,
        top: innerWidth < 1400 ? 0 : undefined,
      }}
      bodyStyle={{ padding: 0 }}
    >
      <InfoModalContent>
        <InfoModalHeader>
          <InfoModalIcon>
            <HelpIcon />
          </InfoModalIcon>

          <ModalCloseButton onClick={onClose}>
            <CloseOutlined />
          </ModalCloseButton>
        </InfoModalHeader>

        <InfoModalBody>
          <InfoModalInnerTitle>
            Was sind Unterstützungsstufen?
          </InfoModalInnerTitle>

          <InfoModalSubText>
            Unterstützungsstufen helfen Unterstützern, sich zu orientieren und
            den Impact ihres Beitrags besser zu verstehen.
          </InfoModalSubText>

          <InfoModalSpesificText>
            So können Unterstützungsstufen aussehen
          </InfoModalSpesificText>

          <img
            src="/image-supports-helper.jpg"
            alt="Beispiel für Unterstützungsstufen"
            style={{
              width: '100%',
              border: '1px solid #D5D7DA',
              borderRadius: 8,
              marginTop: 12,
              display: 'block',
            }}
          />
        </InfoModalBody>

        <InfoModalFooter>
          <InfoModalPrimaryButton onClick={onClose} style={{ width: '100%' }}>
            Verstanden
          </InfoModalPrimaryButton>
        </InfoModalFooter>
      </InfoModalContent>
    </StyledModal>
  );
};

SupportLevelsInfoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SupportLevelsInfoModal;

const InfoModalInnerTitle = styled.div`
/* Text */

  margin-top: 16px;
/* Text lg/Semibold */
font-family: 'Inter';
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 28px;
/* identical to box height, or 156% */

color: #181D27;

  margin-bottom: 4px;

`;

const InfoModalSubText = styled.div`
  
/* Text sm/Regular */
font-family: 'Inter';
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
/* or 143% */

color: #535862;
  margin-bottom: 16px;



`;
const modalShadow = `
  0px 20px 24px -4px rgba(10, 13, 18, 0.08),
  0px 8px 8px -4px rgba(10, 13, 18, 0.03),
  0px 3px 3px -1.5px rgba(10, 13, 18, 0.04)
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
  }
  
`;